import { render, staticRenderFns } from "./studentPayment.vue?vue&type=template&id=4c94d7cf"
import script from "./studentPayment.vue?vue&type=script&lang=js"
export * from "./studentPayment.vue?vue&type=script&lang=js"
import style0 from "./studentPayment.vue?vue&type=style&index=0&id=4c94d7cf&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports